<template>
  <div>
    <div v-if="$store.state.userContributions.length === 0">
      <v-card-title>Nothing Here Yet</v-card-title>
      <v-card-subtitle>Let us know about exiting events, recommendations or anything else you'd like to share</v-card-subtitle>
      <v-btn text @click="$store.commit('setAddContributionVisibility', true)">Make Your First Contribution</v-btn>
    </div>
    <div v-else>
      <v-list class="blue lighten-4" v-for="contribution in $store.state.userContributions" :key="contribution.id" >
        <v-list-item class="blue lighten-4 rounded-xl">
          <v-list-item-content @click="openSocialEventDialog(contribution)">
            <v-list-item-title>{{contribution.short_title}}</v-list-item-title>
            <v-list-item-subtitle>{{contribution.location_id.name}}</v-list-item-subtitle>

            <v-list-item-subtitle v-if="contribution.timeframe">{{contribution.timeframe}}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="editContribution(contribution)"><v-icon small>mdi-pencil</v-icon></v-btn>
            <v-btn icon @click="deleteContribution(contribution)"><v-icon small>mdi-delete</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </div>
    <v-alert class="red lighten-2 deletedContributionAlert" transition="scroll-y-transition" dismissible v-model="contributionDeletedAlert" dense origin="top">
      Your contribution has been deleted
    </v-alert>
    <SocialEventDialog></SocialEventDialog>
  </div>
</template>

<script>
import {store} from "@/store";
import supabase from "@/lib/supabaseClient";
import SocialEventDialog from "@/components/SocialEventDialog.vue";

export default {
  name: "MyContributions",
  components: {SocialEventDialog},
  data() {
    return {
      contributionDeletedAlert: false,
    }
  },

  methods: {
    async deleteContribution(contribution) {
      await supabase
          .from('community')
          .delete()
          .eq('id', contribution.id)
      await store.dispatch('getUserContributions')
      await store.dispatch('getSocialData')
      this.contributionDeletedAlert = true
    },
    openSocialEventDialog(itemData) {
      console.log(itemData)
      store.commit('setSocialEvent', itemData)
    },
    async editContribution(contribution) {
      store.commit('setContributionToEdit', contribution)
      await store.dispatch('getSocialData')
      store.commit('setAddContributionVisibility', true)
    },
    closeAddEventDialog() {
      this.$emit('closeAddEventDialog');
      store.commit('setAddContributionVisibility', false)
    },
  }
}
</script>

<style>
.deletedContributionAlert {
  top: 7vh;
  width: 90vw;
  text-align: center;
  position: fixed;
  left: 5vw!important;
}
</style>
